var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"sider-menu",attrs:{"default-active":_vm.$route.path,"router":true,"collapse":_vm.collapsed,"collapse-transition":false,"active-text-color":"#AFD508","text-color":"#656565"}},_vm._l((_vm.menus),function(menu){return _c('the-sider-menu-item',{key:menu.path,attrs:{"menu":menu}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }